import axios from 'axios'

const VERSION = '25.3.0.3d28b9d4'
const ENTRY_URL = 'static_i18n'

const CACHE = {}
const PROMISE_CACHE = {}

const importMessages = async (url: string) => {
    if (CACHE[url]) {
        return CACHE[url]
    }

    try {
        let request

        if (PROMISE_CACHE[url]) {
            request = PROMISE_CACHE[url]
        } else {
            request = axios.get(url)
            PROMISE_CACHE[url] = request
        }

        const { data } = await request

        delete PROMISE_CACHE[url]
        CACHE[url] = data

        return data
    } catch {
        return {}
    }
}

export const version = VERSION

export const fetchMessages = async (path: string, lang: string, domain = '') => {
    const messages = await importMessages(`${domain}/${ENTRY_URL}/${path}/${lang}.json?v=${VERSION}`)

    return messages
}

export const fetchMessageByKey = async (path: string, lang: string, key: string, domain = '') => {
    const messages = await importMessages(`${domain}/${ENTRY_URL}/${path}/${lang}.json?v=${VERSION}`)

    return messages[key] ?? ''
}

export default {
    version,
    fetchMessageByKey,
    fetchMessages,
}
